import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-dynamic-checkbox',
  templateUrl: './dynamic-checkbox.component.html',
  styleUrls: ['./dynamic-checkbox.component.scss']
})
export class DynamicCheckboxComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;

  constructor(private formgroupDirective: FormGroupDirective) {
    this.formName = formgroupDirective.control;
  }

  ngOnInit(): void {}

  onCheckboxChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (this.field?.onChange && typeof this.field.onChange === 'function') {
      this.field.onChange({ dynamicFormGroup: this.formName }, checked);
    }
  }

}
